import { createFeatureSelector } from '@ngrx/store';

export const orderTypesImagesState = createFeatureSelector<OLO.State, OLO.State.OrderTypesImages[]>('orderTypesImages');
